module.exports = __webpack_public_path__ + "static/media/photo316.92df90de.jpg";